<template>
  <div class="row">
    <nav-danovnik class="col col-md-3 side-menu"/>
    <div class="col-md-9 col-editor col-editor-right" >
      <rest-loading />
      <router-view name="b"/>

      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
        crossorigin="anonymous">
    </div>
  </div>
</template>

<script>
import RestLoading from '@/components/RestLoading.vue';
import NavDanovnik from '@/nav/navDanovnik.vue';

export default {
  components: {
    RestLoading,
    NavDanovnik,
  },
};

</script>

<style>
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.42857143;
  font-size: 16px;
}
</style>
